import React from 'react';
import padStart from 'lodash/padStart';

const Timeline = ({ latestHour }) => {
  let steps = [];
  const hvar_pct = 100.0 / (latestHour-7.0);
  for (var i = 7; i < latestHour + 1; i++) {
    let h = i > 0 ? `${padStart(i, 2, 0)}:00` : null;
    steps.push(
      <div key={`step-${i}`} className="timelineStep" style={{height: hvar_pct+'%'}}>{h}</div>
    );
  }

  return (
    <div className="timelineContainer">
      <div className="timeline">
        <div className="timelineStepsContainer">{steps}</div>
      </div>
    </div>
  );
};

export default Timeline;



// WEBPACK FOOTER //
// ./src/components/common/Calendar/Timeline.js